import { themeBorderRadius } from '$lib/Stores/stores';

import { get } from 'svelte/store';

import type {
    BorderRadius,
    BorderRadiusConfiguration,
    ValueOf,
} from '$lib/types/Components/SharedTypes';

const borderRadiusConfiguration = {
    A: {
        sharp: 'fun-rounded',
        small: 'fun-rounded',
        medium: 'fun-rounded-lg',
        large: 'fun-rounded-lg',
    },
    B: {
        sharp: 'fun-rounded',
        small: 'fun-rounded-lg',
        medium: 'fun-rounded-xl',
        large: 'fun-rounded-full',
    },
    C: {
        sharp: 'fun-rounded',
        small: 'fun-rounded-lg',
        medium: 'fun-rounded-xl',
        large: 'fun-rounded-2xl',
    },
    D: {
        sharp: 'fun-rounded',
        small: 'fun-rounded-xl',
        medium: 'fun-rounded-2xl',
        large: 'fun-rounded-[20px]',
    },
    E: {
        sharp: 'fun-rounded',
        small: 'fun-rounded-2xl',
        medium: 'fun-rounded-[20px]',
        large: 'fun-rounded-3xl',
    },
} as const satisfies BorderRadiusConfiguration;

const componentBorderRadius = {
    blockFrame: borderRadiusConfiguration.D,
    image: borderRadiusConfiguration.D,
    video: borderRadiusConfiguration.D,
    button: borderRadiusConfiguration.B,
    listImage: borderRadiusConfiguration.A,
    faqItem: borderRadiusConfiguration.C,
    sliderImage: borderRadiusConfiguration.D,
    embed: borderRadiusConfiguration.D,
    choiceItem: borderRadiusConfiguration.C,
    fieldsWrapper: borderRadiusConfiguration.C,
    dropdown: borderRadiusConfiguration.C,
    menu: borderRadiusConfiguration.C,
    dropdownItem: borderRadiusConfiguration.A,
    datePickerDay: borderRadiusConfiguration.A,
    videoQuestionFrame: borderRadiusConfiguration.E,
} as const satisfies Record<string, ValueOf<BorderRadiusConfiguration>>;

export const getBorderRadius = (
    component: keyof typeof componentBorderRadius,
    themeSetting?: BorderRadius,
) => {
    const globalThemeSetting = get(themeBorderRadius) as BorderRadius;

    return componentBorderRadius[component][themeSetting ?? globalThemeSetting] ?? 'fun-rounded-md';
};
